export default {
  ['title']: 'COMPETITION PROCEDURE',
  ['sub-title']: 'REGISTRATION & SUBMISSION',
  ['label-detail']: 'Check Detail',
  ['label-sign']: 'Apply Now',
  ['label-submit']: 'Submit Works',
  ['label-guide']: 'Competition Guide',
  ['label-judge']: 'Judge Login'
}
